import ListStore from '../../../shared-lib/stores/ListStore'
import CrmUsageModel from './CrmUsageModel'

export default class CrmUsageStore extends ListStore<CrmUsageModel> {
  fetchMethodName = 'allCrmUsage'
  ModelClass = CrmUsageModel

  crmUsages_api = async (filter: CrmUsagesFilter, pagination?: Pagination) => {
    this.loading = true

    try {
      const crmUsages = await this.fetchUsages_api(filter, pagination)

      if (!crmUsages?.length) return

      this.mergeData(crmUsages)
    } finally {
      this.loading = false
    }
  }

  fetchUsages_api = async (filter: CrmUsagesFilter, pagination?: Pagination): Promise<CrmUsage[] | null> => {
    try {
      const { crmUsages } = await this.rootStore.communication.requester.crmUsages({
        filter,
        pagination,
      })

      return crmUsages ?? []
    } catch (e) {
      console.error(e)
      return null
    }
  }
}